import { IResortPathInfo, IWeatherInfo, ResortWeatherType } from 'api/resort/types';
import { Link } from 'components/blocks/Button';
import { Daily } from 'components/resort/ResortWeather/Daily';
import { Hourly } from 'components/resort/ResortWeather/Hourly';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { useCallback, useState } from 'react';
import { Routes } from 'routes';
import { useAnalytics } from 'util/analytics';
import { isMainLocale } from 'util/i18nFlags';
import { BLUR_CONTENT_STYLE_NAME } from 'theme';
import styles from './styles.module.scss';

export const ResortWeather = (
  {
    weatherInfoDaily,
    weatherInfoHourly,
    pathInfo,
    hasFreshData,
  }: {
    weatherInfoDaily: IWeatherInfo,
    weatherInfoHourly: IWeatherInfo,
    pathInfo: IResortPathInfo
    hasFreshData: boolean,
  },
) => {
  const hasDaily = weatherInfoDaily.weatherItems && weatherInfoDaily.weatherItems.length;
  const hasHourly = weatherInfoHourly.weatherItems && weatherInfoHourly.weatherItems.length;
  const [activeTab, setActiveTab] = useState(hasDaily ? ResortWeatherType.daily : ResortWeatherType.hourly);
  const { t } = useOTSTranslation('common');

  const a = useAnalytics();

  const setDaily = useCallback(() => {
    /* a.viewContent({
      content: 'Hourly Weather Forecast',
    }); */
    setActiveTab(ResortWeatherType.daily);
  }, [a, setActiveTab]);

  const setHourly = useCallback(() => {
    a.viewContent({
      content: 'Hourly Weather Forecast',
    });
    setActiveTab(ResortWeatherType.hourly);
  }, [a, setActiveTab]);

  return (
    <div className={styles.wrap}>
      <div className={styles.tabs}>
        {hasDaily && (
          <>
            <button
              type="button"
              className={activeTab === ResortWeatherType.daily ? styles.active : ''}
              onClick={setDaily}
            >
              {t('resort.weather.daily')}
            </button>
            /
          </>
        )}
        {hasHourly && (
          <button
            type="button"
            className={activeTab === ResortWeatherType.hourly ? styles.active : ''}
            onClick={setHourly}
          >
            {t('resort.weather.hourly')}
          </button>
        )}
        {isMainLocale() && (
          <>
            {hasHourly && '/'}
            <span>
              <Link href={Routes.resortSnowfall(pathInfo)} className={styles.link}>
                {t('resort.weather.historicalSnowfall')}
              </Link>
            </span>
          </>
        )}
      </div>
      <div className={hasFreshData ? '' : BLUR_CONTENT_STYLE_NAME}>
        <Daily weatherDaily={weatherInfoDaily} visible={activeTab === ResortWeatherType.daily} />
        <Hourly weatherHourly={weatherInfoHourly} visible={activeTab === ResortWeatherType.hourly} />
      </div>
    </div>
  );
};
